<!-- 首頁特色機種清單內容(舊版)。新版\home\_motor.vue -->
<template>
  <a :href="motor.showcaseAd.link || 'javascript: void(0)'" v-if="motor && large && motor.showcaseAd" :title="motor.slogan" class="">
    <div class="promotion-image link-zoom-image">
      <div class="ui placeholder" v-if="!current.loaded">
        <div class="square image"></div>
      </div>
      <img :src="motor.showcaseAd.image" :alt="motor.name" @load="onLoad" />
    </div>
  </a>
  <a v-else-if="motor" :key="motor.id" :href="motor.url" target="_blank" class="motor" data-ga-label="特色車款" :alt="motor.name" :title="motor.name">
    <div v-if="motor.styleNames.length > 0" class="label">{{ motor.styleNames[0] }}</div>
    <div v-if="!current.loaded" class="ui placeholder">
      <div class="square image"></div>
    </div>
    <div class="cover link-zoom-image">
      <img :src="motor.coverImages[large ? 600 : 300]" :alt="motor.slogan" @load="onLoad" />
    </div>
    <div class="meta">
      <div class="name">{{ motor.name }}</div>
      <div class="slogan">{{ motor.slogan }}</div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    motor: Object,
    large: Boolean,
    ative: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      current: {
        loaded: false,
      },
    }
  },
  computed: {},
  methods: {
    onLoad() {
      this.current.loaded = true
    },
  },
}
</script>

<style lang="stylus" scoped>
.motor
  margin 1rem
  font-family '微軟正黑體'
  display flex
  flex-direction column
  align-items center
  justify-content center
  .promotion-image
    width 100%
    border-radius 20px
    overflow hidden
    position relative
    margin -1rem
    height calc(100% + 2rem)
    width calc(100% + 2rem)
    display flex
    align-items center
    justify-content center
    img
      width 100%
      height auto
  .label, .slogan
    display none
  .cover
    width 100%
    height 97%
    img
      width 100%
      height auto
  .meta
    text-align center
  .ui.placeholder
    position absolute
    left 0
    right 0
    top 0
    max-width 100%
  .name
    font-size 1.4rem
    padding-top 0.8em
    padding-bottom 2em
    @media (max-width 767px)
      font-size 1.2rem
      padding-top 4vw
      padding-bottom 7vw
</style>
